export const GreenArrowIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
        <path d="M3.6748 9.60559C3.6748 9.88173 3.89866 10.1056 4.1748 10.1056C4.45095 10.1056 4.6748 9.88173 4.6748 9.60559L3.6748 9.60559ZM4.52836 0.580162C4.3331 0.3849 4.01651 0.3849 3.82125 0.580162L0.639271 3.76214C0.444009 3.9574 0.444009 4.27399 0.639271 4.46925C0.834533 4.66451 1.15112 4.66451 1.34638 4.46925L4.17481 1.64082L7.00323 4.46925C7.19849 4.66451 7.51508 4.66451 7.71034 4.46925C7.9056 4.27399 7.9056 3.95741 7.71034 3.76214L4.52836 0.580162ZM4.6748 9.60559L4.67481 0.933716L3.67481 0.933716L3.6748 9.60559L4.6748 9.60559Z" fill="#8FD460"/>
        </svg>
    `,
      }}
    />
  );
};
